'use client'

import { Input } from 'antd'
import { SBDynamicFormInput } from './types'

const SBDynamicFormInputText: SBDynamicFormInput = ({ ...rest }) => {
  return <Input {...rest} autoComplete="off" />
}

export { SBDynamicFormInputText }
